import { Component, OnInit } from '@angular/core';
import { WorkerEndReason } from '../../workers/_types/worker-end-reason';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { WorkersEndReasonsService } from '../../workers/_services/workers-end-reasons.service';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { firstValueFrom } from 'rxjs';
import { LoginService } from '../../login/login.service';

@Component({
    selector: 'app-worker-end-reasons-list',
    templateUrl: './worker-end-reasons-list.component.html',
    styleUrls: ['./worker-end-reasons-list.component.scss'],
    host: { class: 'list-page' },
    standalone: false
})
export class WorkerEndReasonsListComponent implements OnInit {
  public workerEndReasons: WorkerEndReason[] = [];

  public totalRecords: number = 0;
  public loading: boolean = false;
  private lastGridEvent: any;
  public filters: any = {
    name: new Filter(FilterOperation.contains, 'name')
  };
  public allowWrite: boolean = false;
  public allowDelete: boolean = false;

  constructor(
    public workersEndReasonsService: WorkersEndReasonsService,
    private topbarService: TopbarService,
    private router: Router,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private loginService: LoginService
  ) { }

  ngOnInit(): void {
    this.topbarService.setTitle('Razones de baja de operario');
    this.topbarService.addAction('Nuevo', 'pi pi-plus', false, () => {
      this.edit({} as WorkerEndReason);
    });
    
    this.allowWrite = this.loginService.hasPermission("WORKERS_END_REASONS.WRITE");
    this.allowDelete = this.loginService.hasPermission("WORKERS_END_REASONS.DELETE");
  }

  public async loadData($event: any) {

    this.lastGridEvent = $event;

    let params: IParamsCollection = {
      page: { number: $event.first + 1, size: $event.rows }
    }

    if (typeof $event.sortField != 'undefined') params.sort = [($event.sortOrder > 0 ? '-' : '') + $event.sortField];

    //creamos filtros
    params.filter = FilterBuilder.fromObject(this.filters).build();

    let response = await firstValueFrom(this.workersEndReasonsService.all(params));
    this.workerEndReasons = response.data;
    this.totalRecords = response.meta['total'];
    this.topbarService.setCount(this.totalRecords);
  }

  clearFilters() {
    this.filters = {};
    this.search();
  }

  search() {
    this.lastGridEvent.first = 0;
    this.loadData(this.lastGridEvent);
  }

  edit(workerEndReason: WorkerEndReason) {
    this.router.navigate(['workerEndReasons/' + (workerEndReason && Object.keys(workerEndReason).length > 0 ? workerEndReason.id : 0)]);
  }

  delete(workerEndReason: WorkerEndReason) {
    if (this.allowDelete) {
      this.confirmationService.confirm({
        message: '¿Está seguro que desea eliminar la razón de baja?',
        header: 'Eliminar razón de baja',
        acceptLabel: 'Aceptar',
        rejectLabel: 'Cancelar',
        acceptButtonStyleClass: 'p-button-danger',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.workersEndReasonsService.delete(workerEndReason.id).subscribe({
            next: () => {
              this.messageService.add({ closable: true, severity: 'success', detail: 'Razón de baja eliminada correctamente' });
              this.loadData(this.lastGridEvent);
            },
            error: (error: any) => {
              this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
            }
          });
        }
      });
    }
  }

}
